export default "__VITE_ASSET__YnRBaqWL__"